import { render, staticRenderFns } from "./ApuracaoFatura.vue?vue&type=template&id=021ceb86&scoped=true&"
import script from "./ApuracaoFatura.vue?vue&type=script&lang=js&"
export * from "./ApuracaoFatura.vue?vue&type=script&lang=js&"
import style0 from "./ApuracaoFatura.vue?vue&type=style&index=0&id=021ceb86&lang=scss&scoped=true&"
import style1 from "./ApuracaoFatura.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021ceb86",
  null
  
)

export default component.exports